import { render, staticRenderFns } from "./StatsEarners.vue?vue&type=template&id=bf5e4222&"
import script from "./StatsEarners.vue?vue&type=script&lang=js&"
export * from "./StatsEarners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports